import { Button, Message } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./DirectLabsBlockedState.styles";

type BlockedClass = "structural" | "stateRestricted";

interface Props {
  blockedClass: BlockedClass;
  /** Renders the waitlist CTA on the state-restricted block (BUT-1114). */
  onJoinWaitlist?: () => void;
}

/**
 * Blocked-state panel for the direct-lab entry page, reusing existing lab
 * messaging patterns:
 * - structural unavailability (not found / inactive / unsupported /
 *   auth-network false / store-ineligible) → unavailable messaging
 * - state restriction → restricted-state messaging with a waitlist CTA
 *   mirroring the Journey checkout waitlist flow
 */
const DirectLabsBlockedState = ({ blockedClass, onJoinWaitlist }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={styles.container}>
      {blockedClass === "stateRestricted" ? (
        <>
          <div role="alert">
            <Message
              intention="critical"
              title={t(l.labs.CannotOrderInThisState)}
              label={t(l.directLabsCheckout.blocked.stateRestrictedLabel)}
            />
          </div>
          {!!onJoinWaitlist && (
            <div css={styles.waitlistCta}>
              <Button variant="primary" onClick={onJoinWaitlist}>
                {t(l.directLabsCheckout.waitlist.joinButton)}
              </Button>
            </div>
          )}
        </>
      ) : (
        <div role="alert">
          <Message intention="warning" label={t(l.directLabsCheckout.blocked.unavailableLabel)} />
        </div>
      )}
    </div>
  );
};

export { DirectLabsBlockedState };
export type { BlockedClass };
